import Mob from '@/models/Mob';

export default class Trashemon extends Mob {
  id?: string;
  userId?: string;
}
